module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Bagages","placeholder":"Bagages en soute","with-luggage":"Avec bagages","without-luggage":"Sans bagages","indifferent":"Indifférent"},"en":{"title":"Luggage","placeholder":"Checked luggage","with-luggage":"With luggage","without-luggage":"Without luggage","indifferent":"Indifferent"}}')
  delete Component.options._Ctor
}
